import React, { useState, useEffect, useMemo } from "react";
import "./Membership.css";
import GoruLogo from '../img/Goru-logo.svg';
import { actions as usuarioActions, selectors as usuarioSelectors } from "../reducers/usuario";
import { actions as sessionActions, selectors as sessionSelectors } from "../reducers/session";
import { actions as routesActions } from "../reducers/routes";
import LoaderButton from "../components/loaderButton/LoaderButton";
import { onError } from "../libs/errorLib";
import { connect } from "react-redux";
import MembershipOption from "../components/membershipOption/MembershipOption";
import ContactPopup from "../components/contactPopup/ContactPopup";
import { actions as personaActions, selectors as personaSelectors } from "../reducers/persona";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import {
  getAllowedMembershipValuesForUser,
  userHasTipoLicencia,
  MEMBERSHIP_CORPORATIVO,
  MEMBERSHIP_DEMO,
  MEMBERSHIP_PROFESIONAL,
} from "../libs/planLicencia";

const PLAN_BLOCKED_LABEL = "NO INCLUIDO";

function Membership({ dispatch, isLoading, user, persona }) {
  const [isMembershipSelected, setIsMembershipSelected] = useState(null);
  const [nombre, setNombre] = useState("");
  const [value, setValue] = useState("");

  const allowed = useMemo(() => getAllowedMembershipValuesForUser(user), [user]);
  const hasLicencia = userHasTipoLicencia(user);

  useEffect(() => {
    if (!user) {
      dispatch(routesActions.goTo("login"));
      return;
    }
    if (value && !allowed.has(value)) {
      setValue("");
      setIsMembershipSelected(null);
    }
  }, [user, value, allowed, dispatch]);

  useEffect(() => {
    function onLoad() {
      if (user && user.id) {
        dispatch(personaActions.getProfile(user.id));
      }
    }

    onLoad();
  }, [user, dispatch]);

  useEffect(() => {
    function validatePersona() {
      if (persona != undefined && persona != null) {
        setNombre(persona.nombre);
      }
    }

    validatePersona();
  }, [persona]);

  function handleLogout() {
    dispatch(sessionActions.logout());
  }

  function handleOptionClick(v) {
    if (!allowed.has(v)) return;
    setIsMembershipSelected(v);
    setValue(v);
    if (hasLicencia && user) {
      try {
        dispatch(usuarioActions.setMembresia(user.id, v));
      } catch (e) {
        onError(e);
      }
    }
  }

  const selectionAllowed = value && allowed.has(value);

  function handleContinue() {
    try {
      if (!hasLicencia || !selectionAllowed || !user) {
        return;
      }
      dispatch(usuarioActions.setMembresia(user.id, value));
    } catch (e) {
      onError(e);
    }
  }

  const continueDisabled = !hasLicencia || isMembershipSelected === null || !selectionAllowed || isLoading;

  return (
    <div className="Membership container">
      <div className="header d-flex justify-content-between align-items-center">
        <div>
          <img src={GoruLogo} className="App-logo" alt="logo" />
        </div>
        <div>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={handleLogout}
            className="d-flex align-items-center"
            style={{ borderRadius: '20px', padding: '6px 16px', fontSize: '13px' }}
          >
            <i className="bi bi-box-arrow-right me-1"></i> Cerrar Sesión
          </Button>
        </div>
      </div>

      <div className="body">
        <div className="body-header blue">
          {!isLoading &&
            <h1>
              ¡Bienvenid@ {nombre}
            </h1>
          }
          <p>
            Falta poco para comenzar en GORU Programas y Proyectos
          </p>
        </div>

        {!hasLicencia && (
          <Alert variant="warning" className="mx-3">
            Su cuenta no tiene un tipo de licencia asignado. No puede continuar hasta que un administrador
            asigne un plan en el sistema. Si cree que es un error, contacte a soporte o{' '}
            <span
              onClick={handleLogout}
              style={{ textDecoration: 'underline', cursor: 'pointer', fontWeight: 'bold' }}
            >
              cierre sesión aquí
            </span>.
          </Alert>
        )}

        <div className="membership-options center">
          <MembershipOption
            text="Proyectos Personales"
            value={MEMBERSHIP_DEMO}
            onClick={handleOptionClick}
            disabled={!allowed.has(MEMBERSHIP_DEMO)}
            disabledLabel={!allowed.has(MEMBERSHIP_DEMO) ? PLAN_BLOCKED_LABEL : undefined}
          />
          <MembershipOption
            text="Proyectos de Equipo"
            value={MEMBERSHIP_PROFESIONAL}
            onClick={handleOptionClick}
            disabled={!allowed.has(MEMBERSHIP_PROFESIONAL)}
            disabledLabel={!allowed.has(MEMBERSHIP_PROFESIONAL) ? PLAN_BLOCKED_LABEL : undefined}
          />
          <MembershipOption
            text="Programas Corporativos"
            value={MEMBERSHIP_CORPORATIVO}
            onClick={handleOptionClick}
            disabled={!allowed.has(MEMBERSHIP_CORPORATIVO)}
            disabledLabel={!allowed.has(MEMBERSHIP_CORPORATIVO) ? PLAN_BLOCKED_LABEL : undefined}
          />
        </div>

        <div className="continue-container center" style={{ display: "none" }}>
          <LoaderButton
            block
            type="submit"
            className="btn btn-success btn-continue"
            isLoading={isLoading}
            disabled={continueDisabled}
            onClick={handleContinue}
          >
            Continuar
          </LoaderButton>
        </div>
      </div>


      <div className="footer center blue">
        <div className="w-70">
          <div className="float-left">
            <p className="footer-text">
              <strong>GORU</strong> Gestión de Portafolio y Proyectos © 2021
            </p>
          </div>
          <div className="float-right d-flex align-items-center" style={{ gap: '15px' }}>
            <span
              className="footer-text-link"
              onClick={handleLogout}
              style={{ color: '#dc3545', fontWeight: 500 }}
            >
              Cerrar Sesión
            </span>
            <ContactPopup>
              <p className="footer-text-link">Contacto</p>
            </ContactPopup>
          </div>
        </div>

      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  isLoading: usuarioSelectors.getIsLoading(state),
  user: sessionSelectors.getUser(state),
  persona: personaSelectors.getPersona(state),
});

export default connect(mapStateToProps)(Membership);
